import { render, staticRenderFns } from "./OrgPartsTable.vue?vue&type=template&id=2f81f84e&scoped=true&"
import script from "./OrgPartsTable.vue?vue&type=script&lang=js&"
export * from "./OrgPartsTable.vue?vue&type=script&lang=js&"
import style0 from "./OrgPartsTable.vue?vue&type=style&index=0&id=2f81f84e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f81f84e",
  null
  
)

export default component.exports